import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMailPerson(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 176 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M43 46C43 37.1634 50.1634 30 59 30H117C125.837 30 133 37.1634 133 46V74C133 82.8366 125.837 90 117 90H59C50.1634 90 43 82.8366 43 74V46Z"
        stroke="url(#paint0_linear_88_51441)"
        strokeWidth="10"
      />
      <path
        d="M52 39L89.0286 64L124 39"
        stroke="#0D2B57"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="115.5" y="10.5" width="39" height="39" rx="19.5" fill="#0D2B57" />
      <rect x="115.5" y="10.5" width="39" height="39" rx="19.5" stroke="white" />
      <path
        d="M131.875 25.417C131.875 23.6911 133.274 22.292 135 22.292C136.726 22.292 138.125 23.6911 138.125 25.417C138.125 27.1429 136.726 28.542 135 28.542C133.274 28.542 131.875 27.1429 131.875 25.417ZM129.187 34.5326L128.615 34.2812L129.187 34.5326C130.208 32.2074 132.304 30.6253 134.999 30.6253C137.694 30.6253 139.79 32.2074 140.812 34.5326C141.072 35.124 140.943 35.6998 140.581 36.1369C140.215 36.5781 139.611 36.8753 138.937 36.8753H131.062C130.388 36.8753 129.784 36.5781 129.418 36.1369C129.056 35.6998 128.927 35.124 129.187 34.5326Z"
        stroke="white"
        strokeWidth="1.25"
      />
      <defs>
        <linearGradient
          id="paint0_linear_88_51441"
          x1="88"
          y1="30"
          x2="88"
          y2="90"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#98CCFB" />
          <stop offset="1" stopColor="#E5DAD3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMailPerson);
export default ForwardRef;
